import { OrderExternalCollaboratorOutputDto } from '@api/client';
import { Input, Select } from 'antd';
import { Button, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useGetAllUsers from 'shared/_hooks/useGetAllUsers';
import NoData from 'shared/design-system/components/no-data-box';
import { filterOption, formatCurrency } from 'shared/utils/common.utils';

interface Props {
  externalCollaborators: OrderExternalCollaboratorOutputDto[];
  setExternalCollaboratos: React.Dispatch<React.SetStateAction<OrderExternalCollaboratorOutputDto[]>>;
}

const PassiveCycleExternalCollaboratorsTable: React.FC<Props> = ({
  externalCollaborators,
  setExternalCollaboratos,
}) => {
  const { t } = useTranslation();
  const allUsers = useGetAllUsers();

  const hangleChangeCollaborator = (index: number, value: number) => {
    setExternalCollaboratos((prev) => {
      const updatedCollaborators = [...prev];
      updatedCollaborators[index] = { ...updatedCollaborators[index], idUtenteIntranet: value };
      return updatedCollaborators;
    });
  };

  const handleChangeRateQuantity = (index: number, value: string, field: string) => {
    setExternalCollaboratos((prev) => {
      const updatedCollaborators = [...prev];
      updatedCollaborators[index] = { ...updatedCollaborators[index], [field]: value };
      return updatedCollaborators;
    });
  };

  const removeCollaborator = (index: number) => {
    setExternalCollaboratos((prev) => {
      const updatedCollaborators = [...prev];
      updatedCollaborators.splice(index, 1);
      return updatedCollaborators;
    });
  };

  if (externalCollaborators?.length) {
    return (
      <div className="table-responsive table-bordered my-3">
        <Table className={'mt-0 mb-0'}>
          <thead className="bg-red">
            <tr>
              <th scope="col">
                <span>{'Collaborator'}</span>
              </th>
              <th scope="col">
                <span>{'Rate'}</span>
              </th>
              <th scope="col">
                <span>{'Quantity'}</span>
              </th>
              <th scope="col">
                <span>{'A. M/D'}</span>
              </th>
              <th scope="col">
                <span>{'A. Costs'}</span>
              </th>
              <th className="text-center" scope="col" style={{ width: '65px' }}>
                <span>{'Delete'}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {externalCollaborators?.map((collaborator, index) => (
              <tr key={`collaborator-${index}`}>
                <td>
                  <Select
                    showSearch
                    variant="borderless"
                    className="w-100"
                    optionFilterProp="children"
                    filterOption={filterOption}
                    allowClear
                    placeholder={t('Select external user')}
                    key={`fkUtenteEsternos-${index}`}
                    onChange={(e) => hangleChangeCollaborator(index, e as number)}
                    value={collaborator.idUtenteIntranet}
                  >
                    {allUsers
                      ?.filter((el) => el.idTipologia === 3)
                      ?.map((el) => (
                        <Select.Option key={`fkUtenteEsterno-${el.id}-${index}`} value={el.id}>
                          {el.nominativo}
                        </Select.Option>
                      ))}
                  </Select>
                </td>
                <td>
                  <Input
                    type="number"
                    variant="borderless"
                    placeholder={t('Insert rate')}
                    value={collaborator.tariffa}
                    onChange={(e) => handleChangeRateQuantity(index, e.target.value, 'tariffa')}
                    suffix="€"
                  />
                </td>
                <td>
                  <Input
                    type="number"
                    variant="borderless"
                    placeholder={t('Insert quantity')}
                    value={collaborator.numGiornate}
                    onChange={(e) => handleChangeRateQuantity(index, e.target.value, 'numGiornate')}
                  />
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">{collaborator.aggu || '-'}</p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {collaborator.acosti !== undefined ? `${formatCurrency(collaborator.acosti)}€` : '-'}
                    </p>
                  </span>
                </td>

                <td className="text-center">
                  <Button
                    className="btn text-blue-links border-none p-0"
                    type="button"
                    variant="icon"
                    onClick={() => {
                      removeCollaborator(index);
                    }}
                  >
                    <i className="fas fa-xmark text-danger" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  } else {
    return (
      <div className="d-flex justify-content-center mt-3">
        <NoData msg={t('No external collaborators')} />
      </div>
    );
  }
};

export default PassiveCycleExternalCollaboratorsTable;
